import { h } from '@atomify/jsx';

interface FormProps {
    hook?: string;
    action?: string;
    method?: string;
    attr?: string;
    classes?: string;
    children?: NodeList;
}

export const FormElement = ({ hook, action, method, attr, classes, children }: FormProps) => {
    const formAttributes = { action, method, attr };
    return (
        <bpd-form
            {...{
                [`js-hook-${hook}`]: !!hook,
            }}>
            <form class={`c-form ${classes || ''}`} {...formAttributes}>
                {children}
            </form>
        </bpd-form>
    );
};
